import {
  GENERATE_API_KEY_ERROR,
  GENERATE_API_KEY_REQUEST,
  GENERATE_API_KEY_SUCCESS,
  GET_DEVELOPER_API_DATA_ERROR,
  GET_DEVELOPER_API_DATA_REQUEST,
  GET_DEVELOPER_API_DATA_SUCCESS,
} from "./consts";

import axios from "axios";
import { axiosErrorHandler } from "../../utility/action-helper";
import { formatTelegramLog } from "../../utility/formatter-helper";

// get api data
export const getDeveloperApiData =
  (email, user, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: GET_DEVELOPER_API_DATA_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const data = {
      platform_mode: "developer_api",
      request_type: "get_previous_key",
      email,
      user,
    };

    await axios
      .post(url, data)
      .then((res) =>
        dispatch({ type: GET_DEVELOPER_API_DATA_SUCCESS, payload: res.data }),
      )
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getDeveloperApiData(email, user, retryCount + 1),
          GET_DEVELOPER_API_DATA_ERROR,
          user,
          email,
          formatTelegramLog("get_previous_key", data, url),
          0,
          currentPath,
        );
      });
  };

//generate new api key
export const generateApikey =
  (email, user, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: GENERATE_API_KEY_REQUEST });
    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const data = {
      platform_mode: "developer_api",
      request_type: "generate_api",
      email,
      user,
    };

    await axios
      .post(url, data)
      .then((res) =>
        dispatch({ type: GENERATE_API_KEY_SUCCESS, payload: res.data }),
      )
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => generateApikey(email, user, retryCount + 1),
          GENERATE_API_KEY_ERROR,
          user,
          email,
          formatTelegramLog("generate_api", data, url),
          0,
          currentPath,
        );
      });
  };
